import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { CHAT_REPOSITORY } from '../domain/repositories/chat.repository';
import { CHAT_ABUSE_REPORT_REPOSITORY } from '../domain/repositories/chat-abuse-report.repository';
import { ChatRemoteDatasource } from './datasources/remote/chat.remote-datasource';
import { ChatMapper } from './mappers/chat.mapper';
import { ChatRepositoryImpl } from './repositories/chat.repository.impl';

export function provideChatData(): EnvironmentProviders {
  return makeEnvironmentProviders([
    ChatRemoteDatasource,
    ChatMapper,
    { provide: CHAT_REPOSITORY, useClass: ChatRepositoryImpl },
    { provide: CHAT_ABUSE_REPORT_REPOSITORY, useExisting: CHAT_REPOSITORY },
  ]);
}
